import React, { useEffect, useState } from 'react';
import { api } from '@/api/client';
export default function Turni(){
  const [week,setWeek]=useState<any>({});
  const [dateISO,setDateISO]=useState(()=>new Date().toISOString().slice(0,10));
  useEffect(()=>{ api.get('/Shifts/GetWeekShifts',{ params:{ date: dateISO }}).then(({data})=>setWeek(data)); },[dateISO]);
  return (<div><h2>Turni</h2><input type="date" value={dateISO} onChange={(e)=>setDateISO(e.target.value)} />{Object.entries(week).map(([d,v]:any)=>(<div key={d}>{d} — {v.orario} ({v.tipo})</div>))}</div>);
}
